export const surveyOptions = {
  excludeNewWounds: "Exclude new wounds that resolved in time range",
  includeDischarged: "Include discharged"
};
